import { Link } from "react-router-dom";
import { ArrowUpRight, Ruler, Package } from "lucide-react";
import { brl, imgUrl, priceSuffix, discountBadge } from "@/lib/api";

export function ProductCard({ product, index = 0 }) {
  const isM2 = product.pricing_type === "m2";
  return (
    <Link
      to={`/produto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="reveal group flex flex-col overflow-hidden rounded-md border border-slate-200 bg-white transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-sky-500 hover:shadow-xl"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={imgUrl(product.image_url)} alt={product.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-slate-700 backdrop-blur">
          {isM2 ? <Ruler className="h-3 w-3 text-[#0099DD]" /> : <Package className="h-3 w-3 text-[#E5007D]" />}
          {isM2 ? "Por m²" : "Por unidade"}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-5">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{product.category}</p>
        <h3 className="font-display text-lg font-bold leading-tight text-slate-900">{product.name}</h3>
        <p className="line-clamp-2 text-sm text-slate-500">{product.description}</p>
        <div className="mt-auto flex items-end justify-between pt-3">
          <p className="font-mono text-lg font-bold text-slate-900">
            {product.regular_price && <span className="mr-1.5 text-xs font-medium text-slate-400 line-through" data-testid={`regular-price-${product.id}`}>{brl(product.regular_price)}</span>}
            {product.price_table && <span className="mr-1 text-xs font-medium text-slate-400" data-testid={`price-from-${product.id}`}>a partir de</span>}
            {brl(product.price)}
            <span className="text-xs font-medium text-slate-400">{priceSuffix(product)}</span>
          </p>
          {product.regular_price && <span className={`shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-bold ${discountBadge(product).cls}`} data-testid={`discount-badge-${product.id}`}>{discountBadge(product).short}</span>}
          <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors group-hover:text-sky-600" />
        </div>
      </div>
    </Link>
  );
}
